import React, { useContext } from "react";
import styles from "../adCard.scss"
import { Button, Tooltip } from "antd";
import VerifyModal from "../../../../../components/VerifyModal";
import { useAdActions } from "../hooks/useAdActions";
import history from "../../../../../history";
import { EditButton } from "./EditButton";
import { PromotionButton } from "./PromotionButton";
import { AdStatus } from "../../../../../models";
import { getIconUrl } from "../../../../../services/asset";
import { Context as ShareContext } from "../../../../../ShareContex";
import { getAdUrl } from "../../../../../services";
import confirmModal from "../../../../../services/confirmModal";
import { StaticHTML } from "../../../../../components";
import ReactGA from "react-ga4";

export const AdCardActions = (props) => {
  const { ad } = props

  const { adActions, verifyModal, setVerifyModal, blankVerifyModal } = useAdActions(props)
  const { toggleShare } = useContext(ShareContext);

  const handleShareClick = (e) => {
    e.preventDefault()
    ReactGA.event({
      category: "Moji oglasi",
      action: "click",
      label: "Share oglasa"
    });
    const origin = window.location.origin
    const url = getAdUrl(ad)
    toggleShare({ url: `${origin}/oglasi${url}`, title: ad.title })
  }

  const showXMLSyncModal = (e) => {
    e.stopPropagation();
    e.preventDefault();
    confirmModal.show({
      title: "Uređivanje oglasa nije dostupno",
      okText: "U redu",
      iconType: "info",
      cancelButtonProps: { style: { display: 'none' } },
      children: <StaticHTML content={"<p>Ovaj oglas se ažurira automatski putem XML sinkronizacije.<br/> Sve izmjene (cijena, opis, fotografije, status…) potrebno je napraviti u Vašem sustavu iz kojeg šaljete XML podatke. Nakon sljedeće sinkronizacije, izmjene će se automatski prikazati i na našem oglasniku.</p>"} />
    });
  };

  return (
    <React.Fragment>
      <div className={styles.actionsWrapper}>
        <PromotionButton ad={ad} adActions={adActions} />
        {ad.externalId ? (
          <Button
            className={styles.actionButton}
            onClick={showXMLSyncModal}
          >
            XML oglas
          </Button>
        ) : (
          <React.Fragment>
            <EditButton ad={ad} adActions={adActions} />
            <div className={styles.actionsRow}>
              {ad.status !== AdStatus.sold && ad.status !== AdStatus.expired && (
                <Tooltip title="Označi kao prodano">
                  <Button className={styles.actionButton}
                    onClick={adActions.onSold}
                  >
                    <img src={getIconUrl("sold.svg")} />
                  </Button>
                </Tooltip>
              )}

              {!ad.expiringSoon && ad.status === AdStatus.active && (
                <Tooltip title="Pauziraj oglas">
                  <Button className={styles.actionButton} onClick={adActions.onPaused}  >
                    <img src={getIconUrl("pause_outlined.svg")} />
                  </Button>
                </Tooltip>
              )}
              {(ad.status === AdStatus.paused || ad.status === AdStatus.sold) && ad.status !== AdStatus.sold && (

                <Tooltip title="Aktiviraj oglas">
                  <Button
                    className={styles.actionButton}
                    onClick={adActions.onActive}
                  >
                    <img src={getIconUrl("play_outlined.svg")} />
                  </Button>
                </Tooltip>
              )}
              {(ad.expiringSoon || ad.status === AdStatus.expired) && (

                <Tooltip title="Obnovi oglas" >
                  <Button className={styles.actionButton} onClick={adActions.onRenew}  >
                    <img src={getIconUrl("reload_grey.svg")} />
                  </Button>
                </Tooltip>
              )}



              <Tooltip title="Obriši oglas">
                <Button className={styles.actionButton} onClick={adActions.onDelete} >
                  <img src={getIconUrl("trash_can.svg")} />
                </Button>
              </Tooltip>



              {ad.status === AdStatus.active && (
                <Tooltip title="Podijeli">
                  <Button
                    className={styles.actionButton}
                    onClick={handleShareClick}
                  >
                    <img src={getIconUrl("share.svg")} />
                  </Button>
                </Tooltip>
              )}


            </div>
            <VerifyModal
              visible={verifyModal.heading !== "" && verifyModal.content !== "" && verifyModal.redirectPath !== ""}
              onOk={() => {
                history.push(verifyModal.redirectPath), setVerifyModal(blankVerifyModal);
              }}
              onCancel={() => {
                history.replace("/"), setVerifyModal(blankVerifyModal);
              }}
              onClose={() => setVerifyModal(blankVerifyModal)}
              closable={false}
              className={styles.modal}
              {...verifyModal}
            />
          </React.Fragment>
        )

        }
      </div>


    </React.Fragment >
  )
}


// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AdCard/AdCardActions/AdCardActions.tsx